import axios from './index';

export const _signUpUser = (obj) => {
  return axios.post('public/v1/app/s/create', obj);
};

export const _getDashboardData = () => {
  return axios.get('public/v1/app/dashboard');
};

export const _getBalance = () => {
  return axios.get('public/v1/app/get-balance');
};
